import React from 'react';
import { useEditMode } from '../contexts/EditModeContext';

function EditableEvents({ events, onChange }) {
  const { isEditMode } = useEditMode();

  if (!isEditMode) return null;

  const handleEventChange = (index, field, value) => {
    const updated = [...events];
    updated[index][field] = value;
    onChange(updated);
  };

  const handleAddEvent = () => {
    const nextId = events.length > 0 ? Math.max(...events.map(e => parseInt(e.id) || 0)) + 1 : 1;
    onChange([...events, { id: nextId.toString(), label: '' }]);
  };

  const handleRemoveEvent = (index) => {
    onChange(events.filter((_, i) => i !== index));
  };

  return (
    <div style={{ background: '#f0f7f0', padding: '1rem', borderRadius: '8px', marginBottom: '1rem' }}>
      <h4 style={{ color: 'var(--color-primary)', marginBottom: '0.5rem' }}>Edit RSVP Events</h4>
      {events.map((event, index) => (
        <div key={index} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem', alignItems: 'center' }}>
          <input
            type="text"
            value={event.label}
            onChange={(e) => handleEventChange(index, 'label', e.target.value)}
            placeholder="Event name (e.g., Ceremony)"
            style={{ flex: 1, padding: '0.5rem', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <button
            onClick={() => handleRemoveEvent(index)}
            style={{ padding: '0.5rem 1rem', background: '#d32f2f', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            Remove
          </button>
        </div>
      ))}
      <button
        onClick={handleAddEvent}
        style={{ padding: '0.5rem 1rem', background: 'var(--color-primary)', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', marginTop: '0.5rem' }}
      >
        + Add Event
      </button>
    </div>
  );
}

export default EditableEvents;
